var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"open-cards-list"},_vm._l((_vm.cardsByDueDate),function(dateAndCards,index){return _c('OpenCardsDueOnDate',{key:index,attrs:{"dueDate":dateAndCards.due,"cards":dateAndCards.cards}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }